export interface IUploadFileResponse {
  fileUrl: string;
  filename: string;
}
export const ALLOWED_IMAGE_TYPES = [".jpeg", ".png", ".jpg"];
